import { api } from '@/scripts/api';

export const SocialMediaFileService = {
    post(accountId){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/files/generate-upload-url/${accountId}`;

            api.post(service)
                .then(resolve)
                .catch(reject);
        })
    },

    postCopy(accountId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/files/duplicate-from-ids/${accountId}`;

            api.post(service, payload)
            .then(resolve)
            .catch(reject);
        });
    },

    delete(accountId, query){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/files/${accountId}${query}`;

            api.delete(service)
                .then(resolve)
                .catch(reject);
        })
    },
}